export default __webpack_public_path__ + "static/media/globe-border.64736b5a.svg";